module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.user-level')))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('data-form', {
    attrs: {
      "model": "user-levels",
      "entity": _vm.userLevel,
      "fields": _vm.fields,
      "before-submit": _vm.beforeSubmit,
      "after-submit": _vm.afterSubmit
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('related-app-functions')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('data-table', {
    ref: "functionTable",
    attrs: {
      "model": "app-functions",
      "columns": ['[T]name'],
      "isSelected": _vm.isAppFunctionSelected,
      "size": 30
    },
    on: {
      "selection-change": _vm.appFunctionSelectChanged
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-695b7819!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-level/UserLevelDetails.vue
// module id = 1162
// module chunks = 2